import type { InitOptions, Module } from 'i18next';
import i18n from 'i18next';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const getI18nInstance = (
  vocabularyId: string | string[],
  options?: InitOptions,
  languageDetector?: Module,
  debug = false,
) => {
  const ns = Array.isArray(vocabularyId) ? vocabularyId : [vocabularyId];

  options = {
    ns,
    defaultNS: ns[0],
    backend: {
      loadPath: `${window.uefaApiBaseUrl}vocabulary/{{ns}}/{{lng}}`,
      crossDomain: true,
      parse: (data, languages) => {
        const lang = Array.isArray(languages) ? languages[0] : languages;
        return JSON.parse(data)[lang];
      },
    },
    interpolation: {
      escapeValue: false, //disabled for React
    },
    debug,
    fallbackLng: 'en',
    ...options,
  };

  i18n.use(HttpApi);

  languageDetector && i18n.use(languageDetector);

  i18n.use(initReactI18next).init(options);

  return i18n;
};

export default getI18nInstance;
